// extracted by mini-css-extract-plugin
export default {"container":"style_container__axLyN","subheader":"style_subheader__y89RN"};